import { useMutation } from 'react-query';

import { NewForumPost, updateForumPost } from '@utils/backend-api/forumPosts';

export default function useForumPostUpdate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((values: NewForumPost) =>
    updateForumPost(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
